import {
	CATEGORY_LOADING_STATUS,
	CATEGORY_FETCH_ERRORS,
	CATEGORY_FETCH,
	CATEGORY_SET,
} from './types'

const initialState = {
	loading: false,
	categories: [],
	errors: [],
	selectedCategory: null,
}

export const state = { ...initialState }

export default {
	[CATEGORY_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[CATEGORY_FETCH]: (state, payload) => {
		state.categories = payload
	},

	[CATEGORY_FETCH_ERRORS]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CATEGORY_SET]: (state, payload) => {
		state.selectedCategory = payload
	},
}
